<template>
  <TempSelect
    v-if="!loadingGame"
    :formData="formData"
    :id="id"
    :customKey="serverCustomKey"
    :labelInfo="labelInfo"
    :required="labelInfo.required"
    :label="labelInfo.label"
  ></TempSelect>
</template>

<script>
import TempSelect from './TempSelect.vue';
import { mapActions } from 'vuex';
import workTemp from '@mixins/officialSupport/workTemp';
import globalConfig from '@utiles/globalConfig';
export default {
  name: 'TempServer',
  mixins: [workTemp],
  props: {
    gameId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      serverCustomKey: {
        defaultValue: '',
        options: []
      },
      loadingGame: true
    };
  },
  async created() {
    await this.loadServerOptions(this.gameId);
  },
  methods: {
    ...mapActions([
      'getGameList',
      'getServerList',
      'getCharName',
      'createWork'
    ]),
    // 获取服务器列表
    async loadServerOptions(gameId) {
      try {
        this.loadingGame = true;
        const data = await this.getServerList(gameId);
        if (data && data?.length && data.length > 0) {
          // if (data.length == 1) {
          //   this.workForm.serverId = data[0]?.SID;
          //   this.workForm.serverName = data[0]?.REAL_NAME;
          // }
          this.serverCustomKey.options = data.map(item => {
            return {
              label: item.REAL_NAME,
              value: item.SID
            };
          });
          const serverId = globalConfig.getHrefParam('serverId') || '';
          if (serverId) {
            const serverItem = this.serverCustomKey.options.find(
              item => item.value == serverId
            );
            if (serverItem) {
              this.serverCustomKey.defaultValue = serverItem.value;
            }
          }
        } else {
          this.serverCustomKey.options = [];
        }
        this.loadingGame = false;
        return Promise.resolve();
      } catch (error) {
        this.serverCustomKey.options = [];
        return Promise.reject();
      }
    }
  },
  components: {
    TempSelect
  }
};
</script>
